(() => {
  window.AW = window.AW || {};

  class AWMainProductUnisize {
    constructor({ root }) {
      this.root = root;
      // this.unisizeBanner = null;
      this.unisizeTextBanner = null;
      this.observer = null;
      this.syncFrame = null;

      this.observe();
    }

    refresh() {
      this.syncTextBannerPlacement();
      // this.syncBannerPlacement();
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.syncFrame !== null) {
        window.cancelAnimationFrame(this.syncFrame);
        this.syncFrame = null;
      }

      // this.unisizeBanner = null;
      this.unisizeTextBanner = null;
    }

    observe() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (!(document.body instanceof HTMLElement)) {
        return;
      }

      this.observer = new MutationObserver((mutations) => {
        const hasUnisizeAddition = mutations.some(({ addedNodes }) =>
          Array.from(addedNodes).some((node) => {
            if (!(node instanceof Element)) {
              return false;
            }

            return (
              // node.id === "unisize-ex-banner-container"
              // || node.querySelector("#unisize-ex-banner-container") !== null
              node.id === "unisize-text-banner-container"
              || node.querySelector("#unisize-text-banner-container") !== null
            );
          })
        );

        if (!hasUnisizeAddition) {
          return;
        }

        if (this.syncFrame !== null) {
          window.cancelAnimationFrame(this.syncFrame);
        }

        this.syncFrame = window.requestAnimationFrame(() => {
          this.syncFrame = null;
          this.refresh();
        });
      });

      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      this.refresh();
    }

    // syncBannerPlacement() {
    //   const host = this.root.querySelector("[data-aw-unisize-host]");
    //   const banner = document.querySelector("#unisize-ex-banner-container");
    //
    //   if (!(host instanceof HTMLElement) || !(banner instanceof HTMLElement)) {
    //     return;
    //   }
    //
    //   this.unisizeBanner = banner;
    //
    //   if (banner.parentElement !== host) {
    //     host.appendChild(banner);
    //   }
    // }

    syncTextBannerPlacement() {
      const host = this.root.querySelector("[data-aw-unisize-text-host]");
      const textBanner = document.querySelector("#unisize-text-banner-container");

      if (!(host instanceof HTMLElement) || !(textBanner instanceof HTMLElement)) {
        return;
      }

      this.unisizeTextBanner = textBanner;

      if (textBanner.parentElement !== host) {
        host.appendChild(textBanner);
      }
    }
  }

  window.AW.MainProductUnisize = AWMainProductUnisize;
})();
